import { MyLoanInfo } from "pages/application/applicationService";
import "./loans-list-v2.scss";
import Footer from "components/footer/Footer";
import { formatDate } from "utilities/date";
import Overlay from "components/ui/loading-spinners/Overlay/Overlay";
import noLoanImage from "assets/images/v2/no-loan.svg";
import RedesignAnnouncementModal from "pages/announcements/re-design/re-design-modal";
import LoanCardV2 from "components/v2/loan-card/LoanCardV2";

interface LoansListProps {
  readonly data?: MyLoanInfo[];
  readonly isLoading: boolean;
  readonly isFetching: boolean;
  readonly onLoanCardClick: (index: number) => void;
}

export default function LoansListV2({ data, isLoading, isFetching, onLoanCardClick }: LoansListProps) {
  const hasLoans = (data?.length ?? 0) > 0;

  if (isFetching || isLoading) {
    return <Overlay />;
  } else if (!isLoading && data?.length === 1) {
    return <RedesignAnnouncementModal />;
  } else
    return (
      <>
        <RedesignAnnouncementModal />
        <div className="loans-section">
          <div className={`loans-section__wrapper ${hasLoans ? "" : "no-loans-full-width"}`}>
            <div className="loans-section__header">
              <span className="loans-section__header-title">My Loans</span>
            </div>

            {hasLoans ? (
              <div className="loans-section__content">
                <div className="loans-section__header-subtitle">Select a loan below to view your application details.</div>
                <div className="loans-section__card-container">
                  {data?.map((item, index) => {
                    const {
                      property,
                      loanPurpose,
                      loanAmount,
                      status,
                      startedDate,
                      loanNumber,
                      applicationNumber,
                      propertyInfo
                    } = item;
                    return (
                      <div className="loans-section__card" key={loanNumber}>
                        <LoanCardV2
                          property={property}
                          propertyInfo={propertyInfo}
                          loanPurpose={loanPurpose}
                          loanAmount={loanAmount}
                          status={status}
                          startedDate={formatDate(startedDate)}
                          handleLoanCardClick={onLoanCardClick}
                          index={index}
                          loanNumber={loanNumber}
                          applicationNumber={applicationNumber}
                          contextualMessage={item.loanContextualMessage}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <>
                <div className="loans-section__header-subtitle">Select a loan below to view your application details.</div>
                <div className="loans-section__no-loans">
                  <div className="loans-section__no-loans__content">
                    <div className="loans-section__no-loans__icon">
                      <img src={noLoanImage} alt="no-loan" />
                    </div>
                    <div className="loans-section__no-loans__content-text">
                      <div className="loans-section__no-loans__content-text__title">No Loans Available.</div>
                      <div className="loans-section__no-loans__content-text__description">
                        It looks like you don't have any active loans. If you have questions, feel free to connect with your Loan Officer or
                        <br />
                        give us a call at{" "}<a className="loans-section__no-loans__phone-link" href="tel:8772144431">
                          (877) 214-4431
                        </a>.
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="my-loans-footer">
          <Footer />
        </div>
      </>
    );
}
